<template>
<!-- 售后服务-设备使用说明 -->
    <div class="content">
        <div class="forUse" v-for="item in item" :key="item.index">
            <div><span>型号：</span><span>{{item.equipmenttype}}</span></div>
            <div><span>使用说明：</span></div>
            <div><span style="margin-bottom: 32px;text-indent: 10px;display:block;">{{item.equipmentdiscp}}</span></div>
            <div class="video" v-html="item.equipmenturl">{{ item.equipmenturl }}</div>
        </div>
    </div>
</template>

<script>

export default {
    props: {

    },
    data() {
        return {
            item: [],
        };
    },
    computed: {

    },
    created() {
        this.getVideo()
    },
    mounted() {
    },
    watch: {

    },
    methods: {

        getVideo() {
            this.axios.get('/weixin/findallEquipment')
            .then((res)=>{
             /*   res.data.rows.map(item=>{
                    this.item.push(item)
                    return this.item
                })*/
                this.item=res.data
                console.log(this.item)
            }).catch((response)=>{
                console.log(response)
            })
        }
    },
    components: {

    },
};
</script>

<style scoped>

.forUse {
    margin: 28px;
    padding: 38px 24px;
    background: #fff;
    border-radius: 25px;
}
.forUse div {
    line-height: 58px;
}
.forUse div:first-child {
    font-size: 44px;
}

.video {
    width: 100%;
    height: 376px;
}

</style>



// WEBPACK FOOTER //
// src/views/InstructionForUse.vue